import request from '@/utils/request';
export function policyBatchList(data) {
  return request.post('admin/policy-batch/list', data);
}
export function policyBatchDetailHome(data) {
  return request.post('admin/policy-batch/batch-detail', data);
}